import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
// import Contactame from "../contectame/Contactame";


const menuVariants = {
  hidden: { y: -40, opacity: 0 },
  visible: { y: 0, opacity: 1, transition: { when: "beforeChildren", staggerChildren: 0.08 } },
  exit: { y: -40, opacity: 0, transition: { duration: 0.2 } },
};

const itemVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: { opacity: 1, x: 0 },
};

const HeaderComponent = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setMenuOpen(false);
    }
  };

  return (
    <React.Fragment>
      <motion.div
        className="fixed top-0 left-0 z-50 w-full rounded-b-lg shadow-lg bg-neutral-800/30 backdrop-blur-sm"
        style={{
          maskImage:
            "linear-gradient(to bottom, black 90%, transparent 100%)",
          WebkitMaskImage:
            "linear-gradient(to bottom, black 90%, transparent 100%)",
        }}
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
      >
        <div className="flex items-center justify-between px-4 py-3 sm:px-8 md:px-16 lg:px-28 sm:py-4 md:py-5">
          <div className="flex items-center gap-3 sm:gap-4 md:gap-5">
            <img
              src="https://res.cloudinary.com/dhjl9tw4r/image/upload/v1748186244/ChatGPT_Image_25_may_2025_17_17_18_hg0jt7.png"
              alt="Logo"
              className="w-10 h-10 rounded-full sm:w-12 sm:h-12 md:w-16 md:h-16"
            />
            <div className="items-center hidden gap-2 lg:flex lg:gap-5">
              <button className="bg-transparent" onClick={() => scrollToSection("home")}>
                Inicio
              </button>
              <button className="bg-transparent" onClick={() => scrollToSection("Presentacion")}>
                Carta de Presentación
              </button>
              <button className="bg-transparent" onClick={() => scrollToSection("curriculum")}>
                Mi Curriculum
              </button>
              <button className="bg-transparent" onClick={() => scrollToSection("proyectos")}>
                Mis proyectos
              </button>
            </div>
          </div>
          <div className="lg:hidden">
            <button
              className="p-2 rounded focus:outline-none"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Abrir menú"
            >
              <svg
                className="text-white w-7 h-7"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                {menuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8h16M4 16h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </motion.div>
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            key="mobile-menu"
            className="lg:hidden fixed top-24 left-0 w-full bg-black/90 backdrop-blur-md flex flex-col items-center py-6 px-4 gap-2 z-[100] rounded-b-xl shadow-2xl border-b border-neutral-700"
            variants={menuVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <motion.button
              className="w-full px-6 py-3 text-left transition rounded-lg hover:bg-blue-900/30"
              variants={itemVariants}
              onClick={() => scrollToSection("home")}
            >
              Inicio
            </motion.button>
            <motion.button
              className="w-full px-6 py-3 text-left transition rounded-lg hover:bg-blue-900/30"
              variants={itemVariants}
              onClick={() => scrollToSection("Presentacion")}
            >
              Carta de Presentación
            </motion.button>
            <motion.button
              className="w-full px-6 py-3 text-left transition rounded-lg hover:bg-blue-900/30"
              variants={itemVariants}
              onClick={() => scrollToSection("curriculum")}
            >
              Mi Curriculum
            </motion.button>
            <motion.button
              className="w-full px-6 py-3 text-left transition rounded-lg hover:bg-blue-900/30"
              variants={itemVariants}
              onClick={() => scrollToSection("proyectos")}
            >
              Mis proyectos
            </motion.button>
            <motion.div
              className="w-full mt-2"
              variants={itemVariants}
            >
              {/* <Contactame /> */}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </React.Fragment>
  );
};

export default HeaderComponent;
